import CommentCreate from './CommentCreate';

export default CommentCreate;
